<template>
  <div id="gallery">
    <div class="grid-container fluid no-padding">
      <div id="hero">
        <h1>{{ $t('gallery.title') }}</h1>
      </div>
    </div>
    <div class="grid-container margin-huge-bottom">
      <div class="grid-x grid-margin-x">
        <div class="cell" id="img-wall">
          <img v-for="(thisImage, index) in img" :key="index" :src="thisImage" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gallery',
  metaInfo: {
    title: 'Gallery',
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  data () {
    return {
      img: [
        require('../assets/img/feed-1.png'),
        require('../assets/img/feed-2.png'),
        require('../assets/img/feed-3.png'),
        require('../assets/img/feed-4.jpg'),
        require('../assets/img/feed-5.png'),
        require('../assets/img/feed-6.jpg'),
        require('../assets/img/feed-7.jpg'),
        require('../assets/img/feed-8.jpg'),
        require('../assets/img/feed-9.jpg'),
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
#gallery {
  padding-top: 60px;
  #hero {
    padding: 4em 1em;
  }
  #img-wall {
    line-height: 0;
    column-count: 2;
    column-gap: 5px;
    img {
      width: 100% !important;
      height: auto !important;
      padding-bottom: 5px;
    }
  }
}

@media (max-width: 600px) {
  #gallery {
    #img-wall {
      column-count: 1;
    }
  }
}
</style>

